import { useScroll } from "@sciam/shared";
import { useState } from "react";
import { cx } from "~utils";
import styles from "./podcast-sticky-footer.module.css";
import { getBestArticleId } from "~/lib/getBestArticleId";
import { handleTrackClick } from "~/lib/analytics/handleTrackClick";

/**
 * Render a fake sticky footer podcast player
 * @param isPodcastPage {Boolean} Is this a podcast page?
 * @constructor
 */
export default function PodcastStickyFooter({ article }) {
  const { title } = article;
  const image_url = "/static/headphones-icon.png";
  const [isScrolled, setIsScrolled] = useState(false);
  useScroll(({ y: scrollY }) => setIsScrolled(scrollY > 32));

  function handleClick(e) {
    let contentId = getBestArticleId(article);

    e.preventDefault();
    handleTrackClick("podcast-page-stickyfooterpodcast-" + contentId, e);
    const playerElement = document.getElementById("playerAnchor");
    playerElement.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className={cx(styles.podcastStickyFooter, isScrolled ? styles.hasScrolled : "")}>
      <a href="#" onClick={handleClick} className={styles.podcastStickyFooterFlexWrap}>
        <div>
          <img className={styles.headphoneIcon} src={image_url} width="36" alt="" />
        </div>
        <div className={styles.titleWrap}>{title}</div>
      </a>
    </div>
  );
}
